const axios = require("axios");
const { getBaseUrl } = require("./baseUrl");

/* NodeJS */
module.exports = {
  getPreset: (propertyUid) =>
    getBaseUrl().then((url) =>
      axios({
        method: "GET",
        url: `${url}/preset/list?uid=${propertyUid}`,
      })
    ),
};